import { createDCHook, collapseDataFromCall } from '../client';
import { getMeterStatus } from '../services/MeterService';

export const useMeterGetMeterStatus = createDCHook('getMeterStatus', collapseDataFromCall(getMeterStatus), {
  injectables: ['label', 'customerId', 'accountId', 'businessUnit'],
  flattenData: true,
});
